"use strict";
// @ts-nocheck
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// WARN: This component was duplicated from ui-shared since we
// needed a lite version that wasn't tied to any i18 library.
// TODO: Find a way to use ui-shared version of the ConfirmDialog as a lite component
var core_1 = require("@blueprintjs/core");
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Dialog_1 = require("../../ui-shared/src/Dialog");
var style_scss_1 = __importDefault(require("./style.scss"));
var ConfirmDialogComponent = function (props) {
    var onAccept = function () {
        var _a;
        removeDialog();
        (_a = props.accept) === null || _a === void 0 ? void 0 : _a.call(props);
        props.resolve(true);
    };
    var onDecline = function () {
        var _a;
        removeDialog();
        (_a = props.decline) === null || _a === void 0 ? void 0 : _a.call(props);
        props.resolve(false);
    };
    return (react_1.default.createElement(Dialog_1.Wrapper, { icon: "warning-sign", usePortal: false, isOpen: true, onClose: onDecline, size: "sm" },
        react_1.default.createElement(Dialog_1.Body, null,
            react_1.default.createElement(core_1.Icon, { icon: "warning-sign", iconSize: 32, className: style_scss_1.default.icon }),
            react_1.default.createElement("div", null,
                props.message,
                props.body)),
        react_1.default.createElement(Dialog_1.Footer, null,
            react_1.default.createElement(core_1.Button, { id: "confirm-dialog-decline", className: core_1.Classes.BUTTON, type: "button", onClick: onDecline, text: props.declineLabel, tabIndex: 2, intent: core_1.Intent.NONE }),
            react_1.default.createElement(core_1.Button, { id: "confirm-dialog-accept", className: core_1.Classes.BUTTON, type: "button", autoFocus: true, onClick: onAccept, text: props.acceptLabel, tabIndex: 3, intent: core_1.Intent.WARNING }))));
};
var defaultConfirmOptions = {
    title: '',
    accept: function () { },
    acceptLabel: 'Confirm',
    decline: function () { },
    declineLabel: 'Decline'
};
var confirmDialog = function (message, options) {
    return new Promise(function (resolve, _reject) {
        addDialog(__assign(__assign({ message: message }, defaultConfirmOptions), options), resolve);
    });
};
exports.default = confirmDialog;
function addDialog(props, resolve) {
    var body = document.getElementsByTagName('body')[0];
    var div = document.createElement('div');
    div.setAttribute('id', 'confirmDialog-container');
    div.setAttribute('class', style_scss_1.default.ConfirmDialogContainer);
    body.appendChild(div);
    react_dom_1.default.render(react_1.default.createElement(ConfirmDialogComponent, __assign({}, props, { resolve: resolve })), div);
}
function removeDialog() {
    var div = document.getElementById('confirmDialog-container');
    var body = document.getElementsByTagName('body')[0];
    body.removeChild(div);
}
